const MONTHS_SHORT = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
const MONTHS_LONG = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
];

function twoDigitYear(y: number) {
    const s = String(y);
    return s.slice(-2);
}

/**
 * getPeriodLabel(code, opts)
 * code: "YYYY", "YYYYMMM", "YYYYQq", "YYYYWww"
 *  - Year:     "2024"
 *  - Month:    "2022M04"     -> Apr 22
 *  - Quarter:  "2023Q2"      -> Q2 '23
 *  - Week(ISO):"2023W50"     -> W50 '23
 *
 * opts.style: 'short' | 'long'  (default 'short')
 *   short: MMM YY, Qq 'YY, Www 'YY, YYYY
 *   long:  Month YYYY, Qq YYYY, Week ww, YYYY
 */
export function getPeriodLabel(code: string, opts: { style: 'short' | 'long' } = { style: 'short' }) {
    const { style = 'short' } = opts;

    // Patterns
    const reYear = /^(\d{4})$/;
    const reMonth = /^(\d{4})M(0[1-9]|1[0-2])$/;
    const reQuarter = /^(\d{4})Q([1-4])$/;
    const reWeek = /^(\d{4})W(0?[1-9]|[1-4]\d|5[0-3])$/;

    // Year
    let m = code.match(reYear);
    if (m) {
        const y = Number(m[1]);
        return style === 'short' ? String(y) : String(y);
    }

    // Month
    m = code.match(reMonth);
    if (m) {
        const y = Number(m[1]);
        const monthIdx = Number(m[2]) - 1; // 0..11
        if (style === 'short') return `${MONTHS_SHORT[monthIdx]} ${twoDigitYear(y)}`;
        return `${MONTHS_LONG[monthIdx]} ${y}`;
    }

    // Quarter
    m = code.match(reQuarter);
    if (m) {
        const y = Number(m[1]);
        const q = Number(m[2]);
        if (style === 'short') return `Q${q} ’${twoDigitYear(y)}`;
        return `Q${q} ${y}`;
    }

    // Week (ISO number, label only)
    m = code.match(reWeek);
    if (m) {
        const y = Number(m[1]);
        const w = String(m[2]).padStart(2, '0');
        if (style === 'short') return `W${w} ’${twoDigitYear(y)}`;
        return `Week ${w}, ${y}`;
    }

    return code;
}
